
export const BonsaiSpecies = {
    MELALEUCA: 'melaleuca',
    JUNIPER: 'juniper',
    BALD_CYPESS: 'bald cypress',
    WILLOW_FICUS: 'willow ficus',
    CHINESE_ELM: 'chinese elm',
    CHINESE_BOX: 'chinese box'
}

export const BonsaiSpeciesDatabase = {
    "Chinese Box": {
        "Botanical name": "Buxus sinica",
        "Common name": "Chinese Box",
        "Example": "",
        "References": ""
    },
    "Chinese Elm": {
        "Botanical name": "Ulmus parvifolia",
        "Common name": "Chinese Elm",
        "Example": "",
        "References": ""
    },
    "Melaleuca": {
        "Botanical name": "Myrtaceae",
        "Common name": "Melaleuca",
        "Example": "",
        "References": ""
    },
    "Fir": {
        "Botanical name": "Abies",
        "Common name": "Fir",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Bonsai_fir%2C_photo_by_daphneann.jpg/170px-Bonsai_fir%2C_photo_by_daphneann.jpg",
        "References": ""
    },
    "Trident Maple": {
        "Botanical name": "Acer buergerianum",
        "Common name": "Trident Maple",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Trident_Maple_bonsai_52%2C_October_10%2C_2008.jpg/220px-Trident_Maple_bonsai_52%2C_October_10%2C_2008.jpg",
        "References": "[1]:42–43"
    },
    "Field Maple": {
        "Botanical name": "Acer campestre",
        "Common name": "Field Maple",
        "Example": "",
        "References": ""
    },
    "Vine Maple": {
        "Botanical name": "Acer circinatum",
        "Common name": "Vine Maple",
        "Example": "",
        "References": ""
    },
    "Amur Maple": {
        "Botanical name": "Acer ginnala",
        "Common name": "Amur Maple",
        "Example": "",
        "References": ""
    },
    "Montpelier Maple": {
        "Botanical name": "Acer monspessulanum",
        "Common name": "Montpelier Maple",
        "Example": "",
        "References": ""
    },
    "Japanese Maple": {
        "Botanical name": "Acer palmatum",
        "Common name": "Japanese Maple",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Acer_palmatum-Bonsai.jpg/170px-Acer_palmatum-Bonsai.jpg",
        "References": "[1]:38–41"
    },
    "Sycamore Maple": {
        "Botanical name": "Acer pseudoplatanus",
        "Common name": "Sycamore Maple",
        "Example": "",
        "References": ""
    },
    "Red Maple": {
        "Botanical name": "Acer rubrum",
        "Common name": "Red Maple",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Red_Maple%2C_1974-2007.jpg/220px-Red_Maple%2C_1974-2007.jpg",
        "References": ""
    },
    "Desert rose": {
        "Botanical name": "Adenium",
        "Common name": "Desert rose",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Adenium_multiflorum_Mombossa.jpg/220px-Adenium_multiflorum_Mombossa.jpg",
        "References": ""
    },
    "Alder": {
        "Botanical name": "Alnus",
        "Common name": "Alder",
        "Example": "",
        "References": ""
    },
    "Amelanchier": {
        "Botanical name": "Amelanchier canadensis",
        "Common name": "Amelanchier",
        "Example": "",
        "References": ""
    },
    "Ampelopsis": {
        "Botanical name": "Ampelopsis",
        "Common name": "Ampelopsis",
        "Example": "",
        "References": "[1]:44–45"
    },
    "Aralia": {
        "Botanical name": "Dizygotheca castor",
        "Common name": "Aralia",
        "Example": "",
        "References": "[1]:46–47"
    },
    "Strawberry tree": {
        "Botanical name": "Arbutus",
        "Common name": "Strawberry tree",
        "Example": "",
        "References": ""
    },
    "Chrysanthemum": {
        "Botanical name": "Asteraceae",
        "Common name": "Chrysanthemum",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Nagoya_Castle_Chrysanthemum_Competition_2017_11.jpg/170px-Nagoya_Castle_Chrysanthemum_Competition_2017_11.jpg",
        "References": "Chrysanthemum bonsai"
    },
    "Barberry": {
        "Botanical name": "Berberis",
        "Common name": "Barberry",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Berberis_2-16-08.jpg/220px-Berberis_2-16-08.jpg",
        "References": ""
    },
    "Birch": {
        "Botanical name": "Betula",
        "Common name": "Birch",
        "Example": "",
        "References": ""
    },
    "River Birch": {
        "Botanical name": "Betula nigra",
        "Common name": "River Birch",
        "Example": "",
        "References": ""
    },
    "Bougainvillea": {
        "Botanical name": "Bougainvillea",
        "Common name": "Bougainvillea",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Bougainvillea_Bonsai.jpg/170px-Bougainvillea_Bonsai.jpg",
        "References": ""
    },
    "Box, Boxwood": {
        "Botanical name": "Buxus microphylla",
        "Common name": "Box, Boxwood",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Boxwood_demonstration_bonsai_by_Min_Hsuan_Lo.jpg/220px-Boxwood_demonstration_bonsai_by_Min_Hsuan_Lo.jpg",
        "References": "[6]:32–33"
    },
    "Camellia": {
        "Botanical name": "Camellia",
        "Common name": "Camellia",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Japanese_Camellia_bonsai_55%2C_October_10%2C_2008.jpg/170px-Japanese_Camellia_bonsai_55%2C_October_10%2C_2008.jpg",
        "References": "[6]:34–35"
    },
    "Fukien tea tree, Ehretia microphylla": {
        "Botanical name": "Carmona microphylla",
        "Common name": "Fukien tea tree, Ehretia microphylla",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Erethia_theezans_%28bonsa%C3%AF%29.jpg/170px-Erethia_theezans_%28bonsa%C3%AF%29.jpg",
        "References": "[6]:35–36"
    },
    "Hornbeam": {
        "Botanical name": "Carpinus",
        "Common name": "Hornbeam",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Hornbeam%2C_1935-2007.jpg/220px-Hornbeam%2C_1935-2007.jpg",
        "References": ""
    },
    "Cedar": {
        "Botanical name": "Cedrus",
        "Common name": "Cedar",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Cedar_bonsai%2C_Birmingham_Botanical_Gardens.jpg/170px-Cedar_bonsai%2C_Birmingham_Botanical_Gardens.jpg",
        "References": ""
    },
    "Lebanon Cedar": {
        "Botanical name": "Cedrus libani",
        "Common name": "Lebanon Cedar",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Blue_Atlas_Cedar%2C_1950-2007.jpg/170px-Blue_Atlas_Cedar%2C_1950-2007.jpg",
        "References": ""
    },
    "Chinese Hackberry": {
        "Botanical name": "Celtis sinensis",
        "Common name": "Chinese Hackberry",
        "Example": "",
        "References": ""
    },
    "Flowering Quince": {
        "Botanical name": "Chaenomeles",
        "Common name": "Flowering Quince",
        "Example": "",
        "References": ""
    },
    "Cypress": {
        "Botanical name": "Chamaecyparis",
        "Common name": "Cypress",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Chamaecyparis_lawsoniana-Bonsai.jpg/170px-Chamaecyparis_lawsoniana-Bonsai.jpg",
        "References": ""
    },
    "Hinoki Cypress": {
        "Botanical name": "Chamaecyparis obtusa",
        "Common name": "Hinoki Cypress",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Bonsai_IMG_6404.jpg/170px-Bonsai_IMG_6404.jpg",
        "References": ""
    },
    "Sawara Cypress": {
        "Botanical name": "Chamaecyparis pisifera",
        "Common name": "Sawara Cypress",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Chamaecyparis_Pisifera_bonsai.JPG/220px-Chamaecyparis_Pisifera_bonsai.JPG",
        "References": ""
    },
    "Australian grape vine": {
        "Botanical name": "Cissus",
        "Common name": "Australian grape vine",
        "Example": "",
        "References": "[6]:38–39"
    },
    "Citrus aurantifolia": {
        "Botanical name": "Citrus aurantifolia",
        "Common name": "",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Citrus_aurantifolia_bonsai_at_the_BBG%2C_August_2%2C_2008.jpg/220px-Citrus_aurantifolia_bonsai_at_the_BBG%2C_August_2%2C_2008.jpg",
        "References": ""
    },
    "Dogwood": {
        "Botanical name": "Cornus",
        "Common name": "Dogwood",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Bonsai_Pagoda_Dogwood_at_Christchurch_Botanic_Gardens.jpg/170px-Bonsai_Pagoda_Dogwood_at_Christchurch_Botanic_Gardens.jpg",
        "References": ""
    },
    "Smoke Tree": {
        "Botanical name": "Cotinus coggygria",
        "Common name": "Smoke Tree",
        "Example": "",
        "References": ""
    },
    "Cotoneaster": {
        "Botanical name": "Cotoneaster",
        "Common name": "Cotoneaster",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Cotoneaster_bonsai_by_Mike.jpg/220px-Cotoneaster_bonsai_by_Mike.jpg",
        "References": ""
    },
    "Jades": {
        "Botanical name": "Crassula",
        "Common name": "Jades",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Jade-Emyr_jones-Port_Merrion.jpg/220px-Jade-Emyr_jones-Port_Merrion.jpg",
        "References": "[6]:40–41"
    },
    "Hawthorn": {
        "Botanical name": "Crataegus",
        "Common name": "Hawthorn",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/English_Hawthorn%2C_1953-2007.jpg/170px-English_Hawthorn%2C_1953-2007.jpg",
        "References": ""
    },
    "Sugi": {
        "Botanical name": "Cryptomeria",
        "Common name": "Sugi",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Cryptomeria_japonica_-_JBM.jpg/170px-Cryptomeria_japonica_-_JBM.jpg",
        "References": ""
    },
    "Cupressus": {
        "Botanical name": "Cupressus",
        "Common name": "Cupressus",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Monterey_Cypress%2C_GSBF-CN_140%2C_September_12%2C_2008.jpg/170px-Monterey_Cypress%2C_GSBF-CN_140%2C_September_12%2C_2008.jpg",
        "References": ""
    },
    "Common Quince": {
        "Botanical name": "Cydonia oblonga",
        "Common name": "Common Quince",
        "Example": "",
        "References": ""
    },
    "Shrubby Cinquefoil": {
        "Botanical name": "Dasiphora fruticosa",
        "Common name": "Shrubby Cinquefoil",
        "Example": "",
        "References": ""
    },
    "Elaeagnus": {
        "Botanical name": "Elaeagnus",
        "Common name": "Elaeagnus",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Elaeagnus_pungens_-_JBM.jpg/220px-Elaeagnus_pungens_-_JBM.jpg",
        "References": ""
    },
    "Enkianthus": {
        "Botanical name": "Enkianthus",
        "Common name": "Enkianthus",
        "Example": "",
        "References": ""
    },
    "Brush cherries": {
        "Botanical name": "Eugenia",
        "Common name": "Brush cherries",
        "Example": "",
        "References": ""
    },
    "Wolfsmilk": {
        "Botanical name": "Euphorbia",
        "Common name": "Wolfsmilk",
        "Example": "",
        "References": "[6]:42–43"
    },
    "Spindle": {
        "Botanical name": "Euonymus",
        "Common name": "Spindle",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Euonymus_japonicus-Bonsai.jpg/170px-Euonymus_japonicus-Bonsai.jpg",
        "References": ""
    },
    "Beech": {
        "Botanical name": "Fagus",
        "Common name": "Beech",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/American_Beech_bonsai_272%2C_October_10%2C_2008.jpg/170px-American_Beech_bonsai_272%2C_October_10%2C_2008.jpg",
        "References": ""
    },
    "Banyan": {
        "Botanical name": "Ficus benghalensis",
        "Common name": "Banyan",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Ficus_benghalensis1.jpg/170px-Ficus_benghalensis1.jpg",
        "References": ""
    },
    "Weeping Fig": {
        "Botanical name": "Ficus benjamina",
        "Common name": "Weeping Fig",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Phipps_-_014.JPG/170px-Phipps_-_014.JPG",
        "References": ""
    },
    "Fig tree, common fig": {
        "Botanical name": "Ficus carica",
        "Common name": "Fig tree, common fig",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Ficus_carica_bonsai_A_D120701.jpg/170px-Ficus_carica_bonsai_A_D120701.jpg",
        "References": "[6]:46–47"
    },
    "Chinese Banyan Fig": {
        "Botanical name": "Ficus microcarpa",
        "Common name": "Chinese Banyan Fig",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Chinese_Banyan%2C_1971-2007.jpg/220px-Chinese_Banyan%2C_1971-2007.jpg",
        "References": "[6]:44–45"
    },
    "Willow-leaved Fig": {
        "Botanical name": "Ficus neriifolia",
        "Common name": "Willow-leaved Fig",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Ficus_neriifolia_bonsai.jpg/170px-Ficus_neriifolia_bonsai.jpg",
        "References": ""
    },
    "Port Jackson Fig": {
        "Botanical name": "Ficus rubiginosa",
        "Common name": "Port Jackson Fig",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Pjfigbonsai.jpg/170px-Pjfigbonsai.jpg",
        "References": ""
    },
    "Dwarf orange": {
        "Botanical name": "Fortunella hindsii",
        "Common name": "Dwarf orange",
        "Example": "",
        "References": "[6]:48–49"
    },
    "Ash": {
        "Botanical name": "Fraxinus",
        "Common name": "Ash",
        "Example": "",
        "References": ""
    },
    "Fuchsia": {
        "Botanical name": "Fuchsia",
        "Common name": "Fuchsia",
        "Example": "",
        "References": "[6]:54–55"
    },
    "Gardenia": {
        "Botanical name": "Gardenia",
        "Common name": "Gardenia",
        "Example": "",
        "References": "[6]:50–51"
    },
    "Ginkgo": {
        "Botanical name": "Ginkgo biloba",
        "Common name": "Ginkgo",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Ginkgo%2C_1926-2007.jpg/170px-Ginkgo%2C_1926-2007.jpg",
        "References": ""
    },
    "Australian Silver Oak": {
        "Botanical name": "Grevillea robusta",
        "Common name": "Australian Silver Oak",
        "Example": "",
        "References": "[6]:52–53"
    },
    "Ivy": {
        "Botanical name": "Hedera helix",
        "Common name": "Ivy",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Ivy%2C_GSBF-CN_141%2C_September_12%2C_2008.jpg/170px-Ivy%2C_GSBF-CN_141%2C_September_12%2C_2008.jpg",
        "References": ""
    },
    "Honey Locust": {
        "Botanical name": "Gledista triacanthos",
        "Common name": "Honey Locust",
        "Example": "",
        "References": ""
    },
    "Hibiscus": {
        "Botanical name": "Hibiscus syriacus",
        "Common name": "Hibiscus",
        "Example": "",
        "References": ""
    },
    "Holly": {
        "Botanical name": "Ilex",
        "Common name": "Holly",
        "Example": "",
        "References": ""
    },
    "Blue jacaranda": {
        "Botanical name": "Jacaranda mimosifolia",
        "Common name": "Blue jacaranda",
        "Example": "",
        "References": "[6]:56–57"
    },
    "Winter Jasmine": {
        "Botanical name": "Jasminum nudiflorum",
        "Common name": "Winter Jasmine",
        "Example": "",
        "References": ""
    },
    "Dwarf Japanese Garden Juniper": {
        "Botanical name": "Juniperus procumbens",
        "Common name": "Dwarf Japanese Garden Juniper",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Dwarf_Japanese_Juniper%2C_1975-2007.jpg/170px-Dwarf_Japanese_Juniper%2C_1975-2007.jpg",
        "References": ""
    },
    "Chinese Juniper": {
        "Botanical name": "Juniperus chinensis",
        "Common name": "Chinese Juniper",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Goshin%2C_September_15%2C_2007.jpg/170px-Goshin%2C_September_15%2C_2007.jpg",
        "References": ""
    },
    "Blue Juniper": {
        "Botanical name": "Juniperus squamata",
        "Common name": "Blue Juniper",
        "Example": "",
        "References": ""
    },
    "Eastern Juniper": {
        "Botanical name": "Juniperus virginiana",
        "Common name": "Eastern Juniper",
        "Example": "",
        "References": ""
    },
    "Crape myrtle, Indian Lilac": {
        "Botanical name": "Lagerstroemia",
        "Common name": "Crape myrtle, Indian Lilac",
        "Example": "",
        "References": "[6]:58–59"
    },
    "Spanish Flag": {
        "Botanical name": "Lantana camara",
        "Common name": "Spanish Flag",
        "Example": "",
        "References": "[6]:60–61"
    },
    "Japanese Larch, American Larch, Tamarack": {
        "Botanical name": "Larix",
        "Common name": "Japanese Larch, American Larch, Tamarack",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Larix_laricina_bonsai_by_Nick_Lenz.jpg/170px-Larix_laricina_bonsai_by_Nick_Lenz.jpg",
        "References": ""
    },
    "Privet": {
        "Botanical name": "Ligustrum",
        "Common name": "Privet",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Japanese_Privet_at_GSBF_Collection_North%2C_number_236%2C_September_12%2C_2008.jpg/220px-Japanese_Privet_at_GSBF_Collection_North%2C_number_236%2C_September_12%2C_2008.jpg",
        "References": ""
    },
    "Sweetgum": {
        "Botanical name": "Liquidambar",
        "Common name": "Sweetgum",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Sweet_Gum_bonsai_273%2C_October_10%2C_2008.jpg/220px-Sweet_Gum_bonsai_273%2C_October_10%2C_2008.jpg",
        "References": ""
    },
    "Shrubby Honeysuckles": {
        "Botanical name": "Lonicera",
        "Common name": "Shrubby Honeysuckles",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Honeysuckle_bonsai_2-3-08.jpg/170px-Honeysuckle_bonsai_2-3-08.jpg",
        "References": ""
    },
    "Osage Orange": {
        "Botanical name": "Maclura pomifera",
        "Common name": "Osage Orange",
        "Example": "",
        "References": ""
    },
    "Barbados Cherry": {
        "Botanical name": "Malpighia",
        "Common name": "Barbados Cherry",
        "Example": "",
        "References": "[6]:62–63"
    },
    "Star Magnolia": {
        "Botanical name": "Magnolia stellata",
        "Common name": "Star Magnolia",
        "Example": "",
        "References": ""
    },
    "Apple/Crabapple": {
        "Botanical name": "Malus",
        "Common name": "Apple/Crabapple",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Crabapple%2C_1978-2007.jpg/170px-Crabapple%2C_1978-2007.jpg",
        "References": ""
    },
    "Mangifera": {
        "Botanical name": "Mangifera",
        "Common name": "Mangifera",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e2/Mangifera_bonsai.jpg/170px-Mangifera_bonsai.jpg",
        "References": ""
    },
    "Dawn Redwood": {
        "Botanical name": "Metasequoia",
        "Common name": "Dawn Redwood",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Bonsai_Dwarf_Dawn_Redwood_bonsai%2C_July_14%2C_2008.jpg/220px-Bonsai_Dwarf_Dawn_Redwood_bonsai%2C_July_14%2C_2008.jpg",
        "References": ""
    },
    "Orange Jasmine, Satinwood": {
        "Botanical name": "Murraya paniculata",
        "Common name": "Orange Jasmine, Satinwood",
        "Example": "",
        "References": "[6]:64–65"
    },
    "Jaboticaba": {
        "Botanical name": "Myrciaria cauliflora",
        "Common name": "Jaboticaba",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Jaboticaba_bonsai%2C_June_7%2C_2008.jpg/170px-Jaboticaba_bonsai%2C_June_7%2C_2008.jpg",
        "References": "[6]:66–67"
    },
    "Myrtle": {
        "Botanical name": "Myrtus",
        "Common name": "Myrtle",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Myrtle_%28Myrtus_communis%29_bonsai.jpg/170px-Myrtle_%28Myrtus_communis%29_bonsai.jpg",
        "References": "[6]:68–69"
    },
    "Sacred or Heavenly Bamboo": {
        "Botanical name": "Nandina domestica",
        "Common name": "Sacred or Heavenly Bamboo",
        "Example": "",
        "References": ""
    },
    "Bahama berry": {
        "Botanical name": "Nashia inaguensis",
        "Common name": "Bahama berry",
        "Example": "",
        "References": ""
    },
    "Neea": {
        "Botanical name": "Neea",
        "Common name": "",
        "Example": "",
        "References": ""
    },
    "Southern beeches": {
        "Botanical name": "Nothofagus",
        "Common name": "Southern beeches",
        "Example": "",
        "References": ""
    },
    "Olive, European olive": {
        "Botanical name": "Olea europaea",
        "Common name": "Olive, European olive",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Olivera_bonsai.jpg/170px-Olivera_bonsai.jpg",
        "References": "[6]:70–71"
    },
    "Creeper, Boston Ivy": {
        "Botanical name": "Parthenocissus",
        "Common name": "Creeper, Boston Ivy",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Parthenocissus_quinquefolia_bonsai_at_the_BBG%2C_August_2%2C_2008.jpg/220px-Parthenocissus_quinquefolia_bonsai_at_the_BBG%2C_August_2%2C_2008.jpg",
        "References": ""
    },
    "Bamboo": {
        "Botanical name": "Sasa",
        "Common name": "Bamboo",
        "Example": "",
        "References": ""
    },
    "Spruce": {
        "Botanical name": "Picea",
        "Common name": "Spruce",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Filoli_Bonsai_spruce.jpg/220px-Filoli_Bonsai_spruce.jpg",
        "References": ""
    },
    "Andromeda": {
        "Botanical name": "Pieris",
        "Common name": "Andromeda",
        "Example": "",
        "References": ""
    },
    "Sand Pine": {
        "Botanical name": "Pinus clausa",
        "Common name": "Sand Pine",
        "Example": "",
        "References": ""
    },
    "Mugo Pine, Mountain Pine": {
        "Botanical name": "Pinus mugo",
        "Common name": "Mugo Pine, Mountain Pine",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Pinus_mugo_bonsai_at_the_BBG%2C_August_2%2C_2008.jpg/220px-Pinus_mugo_bonsai_at_the_BBG%2C_August_2%2C_2008.jpg",
        "References": ""
    },
    "Japanese White Pine": {
        "Botanical name": "Pinus parviflora",
        "Common name": "Japanese White Pine",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Japanese_White_Pine%2C_1625-2007.jpg/220px-Japanese_White_Pine%2C_1625-2007.jpg",
        "References": ""
    },
    "Japanese Black Pine": {
        "Botanical name": "Pinus thunbergii",
        "Common name": "Japanese Black Pine",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Japanese_Black_Pine%2C_1936-2007.jpg/220px-Japanese_Black_Pine%2C_1936-2007.jpg",
        "References": ""
    },
    "Virginia Pine": {
        "Botanical name": "Pinus virginiana",
        "Common name": "Virginia Pine",
        "Example": "",
        "References": ""
    },
    "Western Yellow Pine": {
        "Botanical name": "Pinus ponderosa",
        "Common name": "Western Yellow Pine",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Western_Yellow_Pine%2C_1966-2007.jpg/220px-Western_Yellow_Pine%2C_1966-2007.jpg",
        "References": ""
    },
    "Pittosporum": {
        "Botanical name": "Pittosporum",
        "Common name": "Pittosporum",
        "Example": "",
        "References": ""
    },
    "Podocarpus, Yew Podocarpus, Kusamaki": {
        "Botanical name": "Podocarpus",
        "Common name": "Podocarpus, Yew Podocarpus, Kusamaki",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Podocarpus_macrophyllus_bonsai.jpg/170px-Podocarpus_macrophyllus_bonsai.jpg",
        "References": "[6]:72–73"
    },
    "Ming Aralia": {
        "Botanical name": "Polyscias fruticosa",
        "Common name": "Ming Aralia",
        "Example": "",
        "References": "[6]:74–75"
    },
    "Dwarf jade, elephant food, elephant bush": {
        "Botanical name": "Portulacaria afra",
        "Common name": "Dwarf jade, elephant food, elephant bush",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Portulacaria_afra_2.jpg/170px-Portulacaria_afra_2.jpg",
        "References": "[7]"
    },
    "Japanese Flowering Cherry (櫻)": {
        "Botanical name": "Prunus serrulata",
        "Common name": "Japanese Flowering Cherry (櫻)",
        "Example": "",
        "References": ""
    },
    "Flowering Apricot (梅)": {
        "Botanical name": "Prunus mume",
        "Common name": "Flowering Apricot (梅)",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Ume_bonsai.jpg/170px-Ume_bonsai.jpg",
        "References": ""
    },
    "Pomegranate": {
        "Botanical name": "Punica granatum",
        "Common name": "Pomegranate",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Punica_granatum_bonsai.jpg/170px-Punica_granatum_bonsai.jpg",
        "References": "[6]:76–77"
    },
    "Firethorn": {
        "Botanical name": "Pyracantha",
        "Common name": "Firethorn",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Pyracantha_crenulata_-_JBM.jpg/170px-Pyracantha_crenulata_-_JBM.jpg",
        "References": "[8]"
    },
    "Oak": {
        "Botanical name": "Quercus",
        "Common name": "Oak",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Daimyo_Oak.jpg/170px-Daimyo_Oak.jpg",
        "References": ""
    },
    "Indian Hawthorn": {
        "Botanical name": "Rhaphiolepis indica",
        "Common name": "Indian Hawthorn",
        "Example": "",
        "References": ""
    },
    "Azalea": {
        "Botanical name": "Rhododendron simsii",
        "Common name": "Azalea",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Satsuki_Azalea%2C_1973-2007.jpg/220px-Satsuki_Azalea%2C_1973-2007.jpg",
        "References": "[6]:78–79"
    },
    "Black Locust": {
        "Botanical name": "Robinia pseudoacacia",
        "Common name": "Black Locust",
        "Example": "",
        "References": ""
    },
    "Chinese Sweet Plum, Pauper's Tea": {
        "Botanical name": "Sageretia",
        "Common name": "Chinese Sweet Plum, Pauper's Tea",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Pauper%27s_Tea_bonsai_115%2C_October_10%2C_2008.jpg/170px-Pauper%27s_Tea_bonsai_115%2C_October_10%2C_2008.jpg",
        "References": "[6]:80–81"
    },
    "Australian Umbrella Tree": {
        "Botanical name": "Schefflera actinophylla",
        "Common name": "Australian Umbrella Tree",
        "Example": "",
        "References": "[6]:82–83"
    },
    "Snow Rose": {
        "Botanical name": "Serissa foetida",
        "Common name": "Snow Rose",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Japanese_Boxthorn%2C_1951-2007.jpg/220px-Japanese_Boxthorn%2C_1951-2007.jpg",
        "References": "[6]:84–85"
    },
    "Rowan and Whitebeam": {
        "Botanical name": "Sorbus",
        "Common name": "Rowan and Whitebeam",
        "Example": "",
        "References": ""
    },
    "Brush cherry, Woolgoolga": {
        "Botanical name": "Syzygium australe",
        "Common name": "Brush cherry, Woolgoolga",
        "Example": "",
        "References": ""
    },
    "Brush cherry": {
        "Botanical name": "Syzygium smithii",
        "Common name": "Brush cherry",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Syzygium_smithii_bons_email.jpg/220px-Syzygium_smithii_bons_email.jpg",
        "References": ""
    },
    "Tamarisk": {
        "Botanical name": "Tamarix",
        "Common name": "Tamarisk",
        "Example": "",
        "References": ""
    },
    "Pond cypress": {
        "Botanical name": "Taxodium ascendens",
        "Common name": "Pond cypress",
        "Example": "",
        "References": ""
    },
    "Bald cypress": {
        "Botanical name": "Taxodium distichum",
        "Common name": "Bald cypress",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Bald_Cypress%2C_1987-2007.jpg/170px-Bald_Cypress%2C_1987-2007.jpg",
        "References": ""
    },
    "Yew": {
        "Botanical name": "Taxus",
        "Common name": "Yew",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Yew_bonsai%2C_Bonsai_Soceity_of_Greater_Hartford.jpg/170px-Yew_bonsai%2C_Bonsai_Soceity_of_Greater_Hartford.jpg",
        "References": "[9]"
    },
    "Thyme": {
        "Botanical name": "Thymus",
        "Common name": "Thyme",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Thymus_bonsai.jpg/170px-Thymus_bonsai.jpg",
        "References": ""
    },
    "Hemlock": {
        "Botanical name": "Tsuga",
        "Common name": "Hemlock",
        "Example": "",
        "References": ""
    },
    "Winged Elm": {
        "Botanical name": "Ulmus alata",
        "Common name": "Winged Elm",
        "Example": "",
        "References": ""
    },
    "Cedar Elm": {
        "Botanical name": "Ulmus crassifolia",
        "Common name": "Cedar Elm",
        "Example": "",
        "References": ""
    },
    "Field Elm": {
        "Botanical name": "Ulmus minor",
        "Common name": "Field Elm",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Smoothleaf_Elm%2C_1982-2007.jpg/220px-Smoothleaf_Elm%2C_1982-2007.jpg",
        "References": ""
    },
    "Chinese Elm": {
        "Botanical name": "Ulmus parvifolia",
        "Common name": "Chinese Elm",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Chinese_Elm%2C_1988-2007.jpg/220px-Chinese_Elm%2C_1988-2007.jpg",
        "References": "[6]:86–87"
    },
    "Japanese Wisteria": {
        "Botanical name": "Wisteria floribunda",
        "Common name": "Japanese Wisteria",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Japanese_Wisteria%2C_1925-2007.jpg/220px-Japanese_Wisteria%2C_1925-2007.jpg",
        "References": ""
    },
    "Chinese Wisteria": {
        "Botanical name": "Wisteria sinensis",
        "Common name": "Chinese Wisteria",
        "Example": "",
        "References": ""
    },
    "Japanese Elm": {
        "Botanical name": "Zelkova serrata",
        "Common name": "Japanese Elm",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Japanese_Zelkova_bonsai_16%2C_October_10%2C_2008.jpg/220px-Japanese_Zelkova_bonsai_16%2C_October_10%2C_2008.jpg",
        "References": ""
    },
    "Chinese Pepper": {
        "Botanical name": "Zanthoxylum",
        "Common name": "Chinese Pepper",
        "Example": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Zanthoxylum_piperitum_bonsai.jpg/220px-Zanthoxylum_piperitum_bonsai.jpg",
        "References": ""
    },

};
